import React, { useState } from 'react';
import { Button, Popconfirm, Tag, Tooltip } from 'antd';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faPlay,
  faCircleCheck,
  faGear,
  faPenToSquare,
  faPause,
  faShareNodes,
  faRotate,
  faTrophy,
  faUser,
  faTrash,
  faCalendar,
  faFile,
  faFileCircleCheck,
  faFileExport
} from '@fortawesome/free-solid-svg-icons';
import ResponsibleModal from '../ResponsibleModal/ResponsibleModal';
import moment from 'moment';
import { openNotificationWithIcon } from '@utilities/notificationWithIcon';
import './CardInfo.scss';
import ClosingProcessReasonModal from '../closing_process_reason_modal/ClosingProcessReasonModal';
import ClosingReasonInfo from '../closing_reason_info/ClosingReasonInfo';
import ClosingReasonForm from '../closing_reason_form/ClosingReasonForm';
import { PROCESS_TAG_COLOR } from '@frontend/constants/colors';
import { SelectionProcessesService } from '@services/selection_processes_service';
import RequestTypeSelectorModal from '../RequestTypeSelectorModal/RequestTypeSelectorModal';
import { getTimeFrom } from "@frontend/helpers/formatDate";
import { TagsGroup } from '@rankmi/ats-app';
import { DEFAULT_REQUISITION_ACTIVE_MODULES } from '@frontend/src/core/workflows/hiring_workflow_app_modules';
const dateFormat = 'DD/MM/yyyy';

const CardInfo = ({
  selectionProcess,
  onPauseProcess,
  onFinishProcess,
  onActivateProcess,
  onRequestClick,
  onResponsibleClick,
  onDeleteClick,
  onUpdateAsTemplate,
  onUpdateRequestType,
  isBasicWithUserColumns,
  closingReasons,
  canSeeMenu,
  currentUser,
  userRole,
  onTransactionalMovementsReport,
  transactionalMovementsReportLoading = false,
}) => {
  const [opentResponsibleModal, setOpenResponsibleModal] = useState(false);
  const [showCloseReasonModal, setShowReasonModal] = useState(false);
  const [showInfoClosingReasonModal, setOpenInfoClosingReason] =
    useState(false);
  const [openRequestType, setOpenRequestType] = useState(false);

  const selectionProcessesService = new SelectionProcessesService();

  const currentUserIsAdmin = currentUser.is_admin || userRole == 'admin';
  const currentUserIsCollaborator = userRole == 'user';

  const getLists = (cols = 2) => {
    let calc = 100 / parseInt(cols);
    return selectionProcess.lists.map((list, key) => {
      return (
        <div
          className="proccess-column"
          style={{ width: `${calc}%` }}
          key={key}
        >
          <div className="quantity">{list.active_applicants}</div>
          <div
            className="capitalize list-name"
            data-toggle="tooltip"
            style={{ fontSize: '16px', fontFamily: 'Roboto' }}
            data-placement="left"
            title={list.name}
          >
            {!!(selectionProcess.title && selectionProcess.description) && (
              <a
                href={`/selection_processes/${selectionProcess.id}`}
                className="title capitalize step-width"
              >
                {list.name}
              </a>
            )}
            {!(selectionProcess.title && selectionProcess.description) && (
              <span
                className="title-card selectable capitalize"
                onClick={handleClickInvalidProcess}
              >
                {list.name}
              </span>
            )}
          </div>
          <div className="rejected">
            <span>Descalificados:</span> {list.disqualified_applicants}{' '}
          </div>
        </div>
      );
    });
  };

  const getCurrentStatusIcon = (status) => {
    if (status === 'active') {
      return (
        <Tooltip title="Proceso Activo" placement="bottom">
          <span className="green-cirlce">●</span>
        </Tooltip>
      );
    } else if (status === 'suspended') {
      return (
        <Tooltip title="Proceso Suspendido" placement="bottom">
          <span className="gray-circle">&#x25CF;</span>
        </Tooltip>
      );
    } else if (status === 'draft') {
      return (
        <Tooltip title="Proceso en Borrador" placement="bottom">
          <span className="gray-cirlce">&#x25CF;</span>
        </Tooltip>
      );
    } else {
      return (
        <Tooltip title="Proceso Cerrado" placement="bottom">
          <span className="blue-circle">&#x25CF;</span>
        </Tooltip>
      );
    }
  };

  const handleResponsibleClick = () => {
    setOpenResponsibleModal(true);
  };

  const handleTrabajandoSync = (e) => {
    e.preventDefault();
    openNotificationWithIcon(
      'success',
      'Sincronizacion activada',
      'Se está realizando la sincronización de candidatos. No vuelvas a presionar el botón mientras se ejecuta esta acción',
      4
    );

    setTimeout(
      () =>
        (window.location.href = `/selection_processes/${selectionProcess.id}/update_selection_process_applicant_list`),
      2000
    );
  };

  const handleClickInvalidProcess = () => {
    openNotificationWithIcon(
      'warning',
      'Configuración de proceso',
      <>
        Este proceso aún no tiene configurados los campos básicos para acceder
        al tablero (título y descripción). Realiza estas configuraciones en la
        edición del proceso.
        <Button
          type="link"
          href={`/selection_processes/${selectionProcess.id}/edit`}
        >
          Editar
        </Button>
      </>
    );
  };

  const handleRequestType = (responses) => {
    // Manejar tanto array como objeto único para retrocompatibilidad
    const requestTypes = Array.isArray(responses) 
      ? responses 
      : responses 
        ? [responses] 
        : [];
    
    // Convertir a formato esperado por el backend
    const requestTypesData = requestTypes
      .filter(r => r.id && r.name)
      .map(r => ({ id: r.id, name: r.name }));
    
    selectionProcessesService.updateRequestType(selectionProcess.id, {
      request_types: requestTypesData,
    }, (updatedProcess) => {
      setOpenRequestType(false);
      openNotificationWithIcon('success', 'Tipos de solicitud actualizados correctamente');
      
      // Llamar al callback del padre con el proceso actualizado
      if (onUpdateRequestType) {
        onUpdateRequestType(selectionProcess.id, updatedProcess);
      }
    }, (error) => {
      openNotificationWithIcon('error', 'Error', error.message);
    });
  };

  const templateButton = () => {
    const is_template = selectionProcess.is_template

    if (is_template) {
      return (
        <>
          <Tooltip title="Remover como plantilla" placement="bottom">
            <Popconfirm
              title={`¿Deseas remover este proceso de las plantillas?`}
              onConfirm={() => onUpdateAsTemplate(selectionProcess.id, false)}
              onCancel={() => {}}
              okText="Remover"
              cancelText="Cancelar"
            >
              <Button type="link" className="icon-item">
                <FontAwesomeIcon icon={faFileCircleCheck} />
              </Button>
            </Popconfirm>
          </Tooltip>
        </>
      )
    } else {
      return (
        <>
          <Tooltip title="Marcar como plantilla" placement="bottom">
            <Popconfirm
              title={`¿Deseas marcar este proceso como plantilla?`}
              onConfirm={() => onUpdateAsTemplate(selectionProcess.id, true)}
              onCancel={() => {}}
              okText="Marcar"
              cancelText="Cancelar"
            >
              <Button type="link" className="icon-item">
                <FontAwesomeIcon icon={faFile} />
              </Button>
            </Popconfirm>
          </Tooltip>
        </>
      )
    }
  };
        

  return (
    <div className="CardInfo card processes-sumary-card cardInfoBlock">
      <div className="card-header CardInfo-header">
        {!!(selectionProcess.title && selectionProcess.description) && (
          <a
            href={`/selection_processes/${selectionProcess.id}`}
            className="title-card title"
            data-turbolinks="false"
          >
            {selectionProcess.title}
          </a>
        )}

        {!(selectionProcess.title && selectionProcess.description) && (
          <span
            className="title-card title selectable"
            onClick={handleClickInvalidProcess}
          >
            {selectionProcess.title ? selectionProcess.title : 'Sin título'}
          </span>
        )}

        <div className="user">
          {getCurrentStatusIcon(selectionProcess.status?.name)}
        </div>

        <div className="user tag-header">
          {selectionProcess.id && (
            <Tag color={PROCESS_TAG_COLOR} className="tag-circle">
              ID: {selectionProcess.id}
            </Tag>
          )}
          {selectionProcess.workflow_id && (
            <Tag color={PROCESS_TAG_COLOR} className="tag-circle">
              REQ{`${selectionProcess.workflow_id}`.padStart(6, '0')}
            </Tag>
          )}
          <Tag
            color={PROCESS_TAG_COLOR}
            className={`capitalize ${
              isBasicWithUserColumns ? '' : 'selectable'
            } tag-circle`}
            onClick={() =>
              isBasicWithUserColumns ? {} : handleResponsibleClick()
            }
          >
            <FontAwesomeIcon icon={faUser} />
            <span className="CardInfo-header-icon">
              {selectionProcess.responsible
                ? selectionProcess.responsible.full_name
                : 'Asignar responsable'}
            </span>
          </Tag>
          {selectionProcess.enterprise_area !== null && (
            <Tag color={PROCESS_TAG_COLOR} className="tag-circle">
              {selectionProcess.enterprise_area.name}
            </Tag>
          )}
          {selectionProcess.request_type_data && (
            <span onClick={() => {
              return !canSeeMenu ? null : setOpenRequestType(true);
            }} style={{ cursor: canSeeMenu ? 'pointer' : 'default' }}>
              <TagsGroup
                tags={
                  Array.isArray(selectionProcess.request_type_data)
                    ? selectionProcess.request_type_data.map(rt => ({
                        name: rt.name,
                        color: PROCESS_TAG_COLOR
                      }))
                    : [{
                        name: selectionProcess.request_type_data.name,
                        color: PROCESS_TAG_COLOR
                      }]
                }
                type="tags"
                tagsToShow={1}
                defaultColor={PROCESS_TAG_COLOR}
                showTooltip={true}
                inline
              />
            </span>
          )}
          <Tooltip 
            title={moment(selectionProcess.created_at,'YYYY-MM-DD hh:mm:ss Z').format(dateFormat)}
          >
            <Tag color={PROCESS_TAG_COLOR} className="tag-circle">
              <FontAwesomeIcon icon={faCalendar} />
              <span className="CardInfo-header-icon">
                {getTimeFrom(moment(selectionProcess.created_at).locale('es'))}
              </span>
            </Tag>
          </Tooltip>

          {selectionProcess.closing_reason !== null && (
            <Tooltip title="Motivo de cierre" placement="bottom">
              <Tag
                color={PROCESS_TAG_COLOR}
                className="tag-circle selectable"
                onClick={() => setOpenInfoClosingReason(true)}
              >
                {selectionProcess.closing_reason.description}
              </Tag>
            </Tooltip>
          )}
        </div>

        <div className="position-icon">
          {currentUserIsAdmin && templateButton()}
          {currentUserIsAdmin && onTransactionalMovementsReport && (
            <Tooltip title="Reporte de Temporalidad" placement="bottom">
              <Button
                type="link"
                className="icon-item"
                disabled={transactionalMovementsReportLoading}
                onClick={() => onTransactionalMovementsReport(selectionProcess.id)}
              >
                <FontAwesomeIcon icon={faFileExport} />
              </Button>
            </Tooltip>
          )}

          {(canSeeMenu || !isBasicWithUserColumns) && (
            <>
              {selectionProcess.workflow_id && (
                <Tooltip title="Ver solicitud" placement="bottom">
                  <Button
                    className="icon-item"
                    type="link"
                    onClick={() => onRequestClick(selectionProcess.workflow_id)}
                  >
                    <FontAwesomeIcon icon={faCircleCheck} />
                  </Button>
                </Tooltip>
              )}

              {(selectionProcess['has_laborum?'] ||
                selectionProcess['has_zonajobs?'] ||
                selectionProcess['has_bumeran?'] ||
                selectionProcess['has_trabajando?'] ||
                selectionProcess['has_chiletrabajos?'] ||
                selectionProcess['has_bne?'] ||
                selectionProcess['has_reqlut?']) && (
                <Tooltip title="Sincronizar candidatos" placement="bottom">
                  <Button
                    className="icon-item"
                    onClick={handleTrabajandoSync}
                    type="link"
                    href={`/selection_processes/${selectionProcess.id}/update_selection_process_applicant_list`}
                  >
                    <FontAwesomeIcon icon={faRotate} />
                  </Button>
                </Tooltip>
              )}

              <Tooltip
                title={
                  selectionProcess.status?.name === 'closed'
                    ? 'Ver proceso'
                    : 'Editar proceso'
                }
                placement="bottom"
              >
                <Button
                  type="link"
                  className="icon-item"
                  href={`/selection_processes/${selectionProcess.id}/edit`}
                >
                  <FontAwesomeIcon
                    icon={
                      selectionProcess.status?.name === 'closed'
                        ? faGear
                        : faPenToSquare
                    }
                  />
                </Button>
              </Tooltip>

              {selectionProcess.status?.name === 'active' && (
                <Tooltip title="Compartir proceso" placement="bottom">
                  <Button
                    type="link"
                    className="icon-item"
                    href={`/selection_processes/${selectionProcess.id}/publish`}
                  >
                    <FontAwesomeIcon icon={faShareNodes} />
                  </Button>
                </Tooltip>
              )}

              {selectionProcess.status?.name === 'active' && (
                <Tooltip title="Suspender proceso" placement="bottom">
                  <Popconfirm
                    title="¿Estás seguro de suspender el proceso?"
                    onConfirm={() => onPauseProcess(selectionProcess.id)}
                    onCancel={() => {}}
                    okText="Aceptar"
                    cancelText="Cancelar"
                  >
                    <Button type="link" className="icon-item">
                      <FontAwesomeIcon icon={faPause} />
                    </Button>
                  </Popconfirm>
                </Tooltip>
              )}

              {((selectionProcess.status.name !== 'active' &&
                currentUserIsAdmin) ||
                ((selectionProcess.status.name === 'draft' ||
                  selectionProcess.status.name === 'suspended') &&
                  currentUserIsCollaborator)) && (
                <Tooltip title="Activar proceso" placement="bottom">
                  <Popconfirm
                    title={`¿Estás seguro que deseas ${
                      selectionProcess.status?.name === 'suspended'
                        ? 'reactivar'
                        : 'activar'
                    } este proceso? El proceso podrá ser editado y recibir candidatos nuevamente.`}
                    onConfirm={() => onActivateProcess(selectionProcess.id)}
                    onCancel={() => {}}
                    okText="Activar"
                    cancelText="Cancelar"
                  >
                    <Button type="link" className="icon-item">
                      <FontAwesomeIcon icon={faPlay} />
                    </Button>
                  </Popconfirm>
                </Tooltip>
              )}

              {selectionProcess.status?.name !== 'closed' && (
                <Tooltip title="Cerrar proceso" placement="bottom">
                  <Popconfirm
                    title="¿Estás seguro de cerrar el proceso?"
                    onConfirm={() => setShowReasonModal(true)}
                    onCancel={() => {}}
                    okText="Aceptar"
                    cancelText="Cancelar"
                  >
                    <Button type="link" className="icon-item">
                      <FontAwesomeIcon icon={faTrophy} />
                    </Button>
                  </Popconfirm>
                </Tooltip>
              )}

              {currentUserIsAdmin && (
                <Tooltip title="Eliminar proceso" placement="bottom">
                  <Popconfirm
                    title="¿Estás seguro de eliminar el proceso? (El proceso será eliminado de forma permanente)"
                    onConfirm={() => onDeleteClick(selectionProcess.id)}
                    onCancel={() => {}}
                    okText="Eliminar"
                    cancelText="Cancelar"
                  >
                    <Button type="link" className="icon-item">
                      <FontAwesomeIcon icon={faTrash} />
                    </Button>
                  </Popconfirm>
                </Tooltip>
              )}
            </>
          )}
        </div>
      </div>

      <div className="card-body proccess-columns-summary">
        {getLists(selectionProcess.lists.length)}
      </div>

      {opentResponsibleModal && (
        <ResponsibleModal
          selectionProcess={selectionProcess}
          handleOpen={setOpenResponsibleModal}
          isOpen={opentResponsibleModal}
          onSubmitResponsible={(e, form) => {
            onResponsibleClick(e, form);
            setOpenResponsibleModal(false);
          }}
        />
      )}

      {showCloseReasonModal && (
        <ClosingProcessReasonModal
          onCloseModal={() => setShowReasonModal(false)}
          showModal={showCloseReasonModal}
        >
          <ClosingReasonForm
            onSubmit={(e, form) =>
              onFinishProcess(e, form, selectionProcess.id)
            }
            closingReasons={closingReasons}
          />
        </ClosingProcessReasonModal>
      )}

      {showInfoClosingReasonModal && (
        <ClosingProcessReasonModal
          onCloseModal={() => setOpenInfoClosingReason(false)}
          showModal={showInfoClosingReasonModal}
        >
          <ClosingReasonInfo
            closingReason={selectionProcess.closing_reason}
            closingReasonComment={selectionProcess.closing_reason_comment}
          />
        </ClosingProcessReasonModal>
      )}

      {openRequestType && (
        <RequestTypeSelectorModal
          id={
            Array.isArray(selectionProcess.request_type_data) && selectionProcess.request_type_data.length > 0
              ? selectionProcess.request_type_data.map(rt => rt.id)
              : selectionProcess.request_type_data?.id
          }
          activeModules={DEFAULT_REQUISITION_ACTIVE_MODULES}
          onChange={handleRequestType}
          onCancel={() => {
            setOpenRequestType(false);
          }}
          visible={openRequestType}
          multiple={Array.isArray(selectionProcess.request_type_data)}
        />
      )}
    </div>
  );
};

export default CardInfo;
